import React, { useEffect, useState } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import * as yup from 'yup';
import { Formik } from 'formik';
import { StatusCodes } from 'http-status-codes';

import WhitePad from '../../../../components/common/WhitePad/WhitePad';
import BrandsApi from '../../../../services/api/BrandsApi';
import { UPLOAD_MAX_SIZE_IMAGE, SUPPORTED_IMAGE_FORMATS } from '../../../../utils/constants';
import FileInputComponent from '../../../../components/common/forms/FileInput/FileInputComponent';
import TextInputComponent from '../../../../components/common/forms/TextInput/TextInputComponent';
import FormRow from '../../../../components/common/forms/Row/FormRow';
import PrimaryButton from '../../../../components/common/forms/Button/PrimaryButton';
import TitleComponent from '../../../../components/common/forms/Title/TitleComponent';
import FormWrapper from '~/src/components/common/forms/FormWrapper/FormWrapper';
import BorderlessButton from '~/src/components/common/forms/Button/BorderlessButton';
import styled from 'styled-components';

const validationSchema = yup.object().shape({
  name: yup.string().label('Name').min(2, 'Name should be at least 2 symbols').required('Name is required'),
  logo: yup
    .mixed()
    .test('fileSize', 'Max upload file 3MB', (value) => {
      if (typeof value === 'undefined' || value.length <= 0) {
        return true;
      }
      return value[0].size <= UPLOAD_MAX_SIZE_IMAGE;
    })
    .test('fileType', 'Please use filetype JPG, JPEG, or PNG', (value) => {
      if (typeof value === 'undefined' || value.length <= 0) {
        return true;
      }

      return SUPPORTED_IMAGE_FORMATS.includes(value[0].type);
    }),
});

export default function BrandEdit(): JSX.Element {
  const { id } = useParams();
  const [itemData, setItemData] = useState(null);
  const history = useHistory();
  // const [logo, setLogo] = useState(null);

  const getItem = async () => {
    const res = await BrandsApi.get(id);
    setItemData(res.data);
  };
  const saveItem = async (values, setSubmitting) => {
    setSubmitting(true);
    const res = await BrandsApi.update(id, values);
    if (res.status === StatusCodes.OK) {
      history.push('/brands');
    } else {
      setSubmitting(false);
    }
  };

  const onHandleChange = (event, setFieldValue) => {
    const { files } = event.target;
    setFieldValue('logo', files);
  };

  const onDelete = async () => {
    const res = await BrandsApi.delete(id);
    if (res.status === StatusCodes.OK) {
      history.push('/brands');
    }
  };

  // getLogo = async () => {
  //   const certificatesResp = await certificateApi.getCertificate(this.state.editUserId);
  //   this.setState({ certificates: certificatesResp.data.certificates });
  // };

  useEffect(() => {
    getItem(id);
    // getLogo()
  }, []);

  return (
    <WhitePad>
      <TitleComponent
        title="Edit Brand"
        onLeftHandler={() => {
          history.goBack();
        }}
      />
      <FormWrapper>
        {itemData !== null ? (
          <Formik
            initialValues={{
              name: itemData.name,
              logo: [],
            }}
            validationSchema={validationSchema}
            onSubmit={(values, { setSubmitting }) => saveItem(values, setSubmitting)}
          >
            {({ values, handleChange, handleBlur, handleSubmit, isSubmitting, setFieldValue }) => (
              <div style={{ width: '454px' }}>
                <form onSubmit={handleSubmit} autoComplete="off" style={{ width: '454px' }}>
                  <FormRow>
                    <TextInputComponent
                      name="name"
                      label="Name"
                      value={values.name}
                      onBlur={handleBlur}
                      onChange={handleChange}
                      cols={12}
                    />
                  </FormRow>
                  <FormRow>
                    <FileInputComponent
                      name="logo"
                      value={values.logo}
                      onBlur={handleBlur}
                      onChange={onHandleChange}
                      setFieldValue={setFieldValue}
                      cols={12}
                    />
                  </FormRow>
                  <ActionWrapper>
                    <PrimaryButton isSubmitting={isSubmitting} type="submit" title="Save" />
                    <BorderlessButton
                      marginLeft="30px"
                      size="sm"
                      type="submit"
                      onClick={onDelete}
                      title="Delete"
                    />
                  </ActionWrapper>
                </form>
              </div>
            )}
          </Formik>
        ) : null}
      </FormWrapper>
    </WhitePad>
  );
}

const ActionWrapper = styled.div`
  display: flex;
  align-items: center;
`;
